import styled from 'styled-components';

import { colors, ColorType } from '../../../core';

interface IconContainerProps {
  borderColor?: ColorType;
}

export const IconContainer = styled.div<IconContainerProps>`
  ${({ borderColor, theme }) =>
    borderColor
      ? `border: 1px solid ${borderColor};`
      : `border: 1px solid ${theme.pdfIconColor || colors.primary};`}
  border-radius: 3px;
  height: 29px;
  width: 29px;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  > svg {
    cursor: pointer;
  }
`;
